import { API_BASE_URL, apiFetch, buildAuthHeaders, httpJson } from "./client";

export async function createPersonalPropertyAssessment(payload) {
  return await httpJson("/personal-property/assessments", {
    method: "POST",
    body: payload,
  });
}

export async function uploadPersonalPropertySources(assessmentId, files) {
  const id = String(assessmentId || "").trim();
  if (!id) throw new Error("assessmentId is required");
  const list = Array.from(files || []);
  if (list.length < 1) return { assessment_id: id, uploaded: [] };
  const form = new FormData();
  list.forEach((f) => form.append("files", f));
  const { data } = await apiFetch(`/personal-property/assessments/${encodeURIComponent(id)}/upload`, {
    method: "POST",
    body: form,
  });
  return data || { assessment_id: id, uploaded: [] };
}

export async function runPersonalPropertyAssessment(assessmentId, { maxItems = 100, priceLookup = true } = {}) {
  const id = String(assessmentId || "").trim();
  if (!id) throw new Error("assessmentId is required");
  const qs = new URLSearchParams({
    max_items: String(maxItems),
    price_lookup: priceLookup ? "1" : "0",
  }).toString();
  return await httpJson(`/personal-property/assessments/${encodeURIComponent(id)}/run?${qs}`, {
    method: "POST",
  });
}

export async function getPersonalPropertyAssessment(assessmentId) {
  const id = String(assessmentId || "").trim();
  if (!id) throw new Error("assessmentId is required");
  return await httpJson(`/personal-property/assessments/${encodeURIComponent(id)}`, {
    method: "GET",
  });
}

export async function downloadContentsCornerCsv(assessmentId) {
  const id = String(assessmentId || "").trim();
  if (!id) throw new Error("assessmentId is required");
  const path = `/personal-property/assessments/${encodeURIComponent(id)}/export/xactimate-contents.csv`;
  const url = `${API_BASE_URL}${path}`;
  const res = await fetch(url, { method: "GET", headers: buildAuthHeaders() });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`CSV export failed (${res.status}): ${txt || "request failed"}`);
  }
  const blob = await res.blob();
  return { blob, filename: `xactimate-contents-${id}.csv` };
}

export async function calculatePackoutEstimate(payload) {
  return await httpJson("/personal-property/packout/calculate", {
    method: "POST",
    body: payload,
  });
}

async function downloadPackoutBlob(path, payload, fallback) {
  const url = `${API_BASE_URL}${path}`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      ...buildAuthHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload || {}),
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Packout export failed (${res.status}): ${txt || "request failed"}`);
  }
  const blob = await res.blob();
  const cd = String(res.headers.get("content-disposition") || "");
  const m = cd.match(/filename="?([^";]+)"?/i);
  const filename = m && m[1] ? m[1] : fallback;
  return { blob, filename };
}

export async function downloadPackoutEstimateCsv(payload) {
  return await downloadPackoutBlob("/personal-property/packout/export/csv", payload, "packout_estimate.csv");
}

export async function downloadPackoutEstimatePdf(payload) {
  return await downloadPackoutBlob("/personal-property/packout/export/pdf", payload, "packout_estimate.pdf");
}
